import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";

export const StudentViews = () => (
  <Suspense fallback={<Loading cover="content" />}>
    <Switch>
      <Route path="" component={lazy(() => import(`./pages`))} />
      <Redirect from="/" to="/student/dashboard" />
    </Switch>
  </Suspense>
);

export default React.memo(StudentViews);
